import { render, staticRenderFns } from "./AddCardModal.vue?vue&type=template&id=1523296a&scoped=true&"
import script from "./AddCardModal.vue?vue&type=script&lang=js&"
export * from "./AddCardModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1523296a",
  null
  
)

export default component.exports